import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ISessionLecturerAttendancePostData } from 'src/app/shared/models/session-group/session-lecturer-attendance-post-data.model';
import { ISessionLecturerCreateData, ISessionLecturerUpdateData } from 'src/app/shared/models/session-group/session-lecturer-change-data.model';
import { ISessionLecturer } from 'src/app/shared/models/session-group/session-lecturer.model';
import { CallableNames, DbService } from '../../db.service';
import { ILecturerSessionDataItem } from '../../store/sessions-lecturer-store.service';

@Injectable({
  providedIn: 'root'
})
export class SessionLecturersService {

  constructor(
    private dbService: DbService,
  ) { }

  public postSessionLecturerAttendance(data: ISessionLecturerAttendancePostData) {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesSessionLecturersPostAttendance, data });
    return this.dbService.handleObs(obs);
  }

  public updateSessionLecturer(data: ISessionLecturerUpdateData): Observable<ILecturerSessionDataItem> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesSessionLecturersUpdate, data });
    return this.dbService.handleObs(obs, { succSilent: true });
  }

  public createSessionLecturer(data: ISessionLecturerCreateData): Observable<ISessionLecturer> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesSessionLecturersCreate, data });
    return this.dbService.handleObs(obs, { succSilent: true });
  }

  public deleteSessionLecturer(id: number): Observable<void> {
    const obs = this.dbService.runCallable({ name: CallableNames.callablesSessionLecturersDelete, data: id });
    return this.dbService.handleObs(obs, { succSilent: true });
  }
}
